import CloseIcon from "@assets/svg/CloseIcon";
// @ts-ignore
import ProfileImg from "@assets/profilePic1.png";
// @ts-ignore
import HiringCompanyImg from "@assets/images/hiringCompany.png";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@components/ui/dialog";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  getJobSubmissionQueue,
  removeJobSubmissionQueueItem,
  submitJobSubmissionQueue,
} from "@endpoints/job.service";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import LoadingAnimation from "@assets/svg/LoadingAnimation";

interface SubmissionQueueModalProps {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  jobId: string;
  onSubmit: () => void;
}

const Card = ({ data, enqueueSnackbar, onRemoveSuccess }: any) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = async () => {
    try {
      setIsRemoving(true);
      const { success } = await removeJobSubmissionQueueItem(data?._id);
      if (success) onRemoveSuccess();
      enqueueSnackbar("Candidate removed successfully.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <div className="flex items-center justify-between py-4 px-3 border-b">
      <div className="flex items-center gap-6">
        <img
          src={data?.candidate?.profilePic}
          className="w-[36px] h-[36px] rounded-full"
        />
        <div className="flex flex-col">
          <span className="font-bold text-xs text-primary">
            {data?.candidate?.firstName} {data?.candidate?.lastName}
          </span>
          <span className="font-medium text-xs text-light-black">
            CA-123BNM
          </span>
        </div>
      </div>
      <span className="font-bold text-xs text-primary">
        {data?.matchingPercentage}% matched
      </span>
      <button
        disabled={isRemoving}
        onClick={handleRemove}
        className="flex items-center gap-2 font-semibold text-xs h-8 px-3 text-primary bg-gray-200 rounded-md hover:bg-gray-300"
      >
        Remove
        {isRemoving ? <LoadingAnimation color="#2e2e2e" /> : null}
      </button>
    </div>
  );
};

const SubmissionQueueModal = ({
  openModal,
  setOpenModal,
  jobId,
  onSubmit,
}: SubmissionQueueModalProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const [jobSubmissionQueue, setJobSubmissionQueue] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function fetchJobSubmissionQueue(refetch = false) {
    try {
      if (!refetch) setIsLoading(true);
      const { success, data } = await getJobSubmissionQueue(jobId);
      if (success) {
        setJobSubmissionQueue(data);
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  }

  const handleSubmitToHiringCompany = async () => {
    try {
      setIsSubmitting(true);
      const { success } = await submitJobSubmissionQueue(jobId);
      if (success) {
        setOpenModal(false);
        onSubmit();
        enqueueSnackbar("All queued candidates submitted successfully.", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const onRemoveSuccess = () => {
    fetchJobSubmissionQueue(true);
  };

  const isSubmitDisabled =
    !jobSubmissionQueue?.length || isSubmitting || isLoading;

  useEffect(() => {
    if (jobId) {
      fetchJobSubmissionQueue();
    }
  }, [jobId, openModal]);

  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogContent showCloseButton={false} className="bg-white !max-w-2xl">
        <DialogClose asChild>
          <button
            onClick={() => {
              setOpenModal(false);
            }}
            className="h-max ml-auto rounded-md hover:bg-gray-50 absolute right-3 top-3"
          >
            <CloseIcon className={"w-5 h-5"} />
          </button>
        </DialogClose>
        <DialogTitle className="flex gap-5 mr-5">
          <div className="flex flex-col gap-1.5">
            <span className="text-lg font-bold text-primary">
              Submission Queue
            </span>
            <span className="text-xs font-medium text-light-black">
              Review the candidates you’ve added and submit them together to the
              hiring company.
            </span>
          </div>
          {/* <div className="flex flex-col rounded-lg border border-gray-200 p-2.5 gap-3">
            <span className="font-semibold text-xs text-light-black">
              Hiring company details
            </span>
            <div className="flex items-center gap-2.5">
              <img
                src={HiringCompanyImg}
                className="w-[48px] h-[48px] rounded-full"
              />
              <div className="flex flex-col gap-0.5">
                <span className="font-semibold text-xs text-primary">
                  ABC Solutions Pvt. Ltd.
                </span>
                <span className="font-normal text-xs text-primary">
                  abc_solutions@yahoo.com
                </span>
              </div>
            </div>
          </div> */}
          <div className="flex-col rounded-lg border border-gray-200 p-2.5 gap-3 inline-flex">
            <span className="font-semibold text-xs text-light-black">
              Hiring company details
            </span>

            <div className="flex items-center gap-2.5">
              <img
                src={HiringCompanyImg}
                className="w-[48px] h-[48px] rounded-full flex-shrink-0"
              />

              <div className="flex flex-col gap-0.5">
                <span className="font-semibold text-xs text-primary">
                  ABC Solutions Pvt. Ltd.
                </span>
                <span className="font-normal text-xs text-primary">
                  abc_solutions@yahoo.com
                </span>
              </div>
            </div>
          </div>
        </DialogTitle>
        {/* List Section */}

        {isLoading || !jobSubmissionQueue?.length ? (
          <div className="h-[25rem] flex items-center justify-center">
            {isLoading ? (
              <LoadingAnimation color="#2e2e2e" className="w-7 h-7" />
            ) : (
              <span className="text-xs font-medium text-light-black">
                You haven’t added any candidates yet. Add candidates to review
                and submit them.
              </span>
            )}
          </div>
        ) : jobSubmissionQueue?.length ? (
          <div className="h-[25rem] overflow-y-scroll no-scrollbar">
            {jobSubmissionQueue?.map((queueItem) => {
              return (
                <Card
                  data={queueItem}
                  enqueueSnackbar={enqueueSnackbar}
                  onRemoveSuccess={onRemoveSuccess}
                />
              );
            })}
          </div>
        ) : null}

        <DialogFooter>
          <button
            onClick={handleSubmitToHiringCompany}
            disabled={isSubmitDisabled}
            className={`flex items-center gap-2 text-xs font-semibold text-white bg-primary rounded-md h-8 px-4 ${
              isSubmitDisabled ? "opacity-50" : "hover:bg-black"
            }`}
          >
            Submit to Hiring Company
            {isSubmitting ? <LoadingAnimation /> : null}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SubmissionQueueModal;
